import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";
import RestService from "./../../Restservice";
import CustomTable from "./../../component/CustomTable";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Common from "./../../common.json";
import FAQ from "./FAQ";
const EditOption = React.lazy(() => import("./../../component/EditOption"));

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function SignalStock() {
  let userParams = useParams();
  let sector_id = userParams.sector_id ? userParams.sector_id : 0;

  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [ntime, setntime] = useState(false);
  const [signalName, setsignalName] = useState("");

  useEffect(() => {
    setLoading(true);
    RestService.getSectorStock(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.response);
        setsignalName(response.data.response.sectorName);
      },
      mobile,
      web_token,
      sector_id
    );
  }, [ntime, mobile, web_token, sector_id]);

  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  return (
    <>
      <GlobalHelmet {...Common?.sector} />
      <Helmet>
        <title>{globaldata?.metaData?.metatitle}</title>
        <meta
          property="og:title"
          content={globaldata?.metaData?.metatitle}
        ></meta>
        <meta
          name="description"
          content={globaldata?.metaData?.metaDescription}
        />
        <meta name="keywords" content={globaldata?.metaData?.metaKeyword} />
      </Helmet>

      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <button
                  className="btn btn-success"
                  title="Reload Page"
                  onClick={refreshPage}
                >
                  <i className="fa fa-refresh"></i>
                </button>
                &nbsp;
                {mobile && web_token && <EditOption />}
                <Link to="/nse-sectors-list" className="btn btn-success ml-2">
                  <i className="fa fa-arrow-left"></i>
                </Link>
              </div>
              <Breadcrumbs
                page={
                  '<a href="/nse-sectors-list/"> Sector </a> :<span className="highlighttext">' +
                  signalName +
                  " </span> "
                }
              />

              <div>
                <div className="mt-3">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        {!globaldata.getDetails ? (
                          ""
                        ) : (
                          <>
                            <CustomTable
                              key={globaldata?.setColumn?.dataField}
                              columndata={
                                globaldata.setColumn ? globaldata.setColumn : ""
                              }
                              marketdata={
                                globaldata.getDetails
                                  ? globaldata.getDetails
                                  : ""
                              }
                              redirectlink="/stocks/"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {globaldata?.faqsData && <FAQ faqs={globaldata?.faqsData} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
